import * as actions from "../actions";
import * as types from "../types";
import { SchemaNodeType } from "../types";
import { DateTime } from "luxon";
import { getUID, logger } from "../system/utils";

const initialState: types.IState = {
  dataContext: null,
  selectedNode: {
    nodeID: 0,
    type: SchemaNodeType.None,
    code: "",
    name: "",
    color: null,
    timezone: null,
    menu: [],
    indicator: []
  },
  panels: {
    left: true,
    right: false,
    bottom: true
  },
  darkMode: false,
  language: "en-us",
  alerts: [],
  filter: {
    local: {
      mode: "REAL_TIME",
      crew: "ALL",
      shift: "ALL",
      selectedFrom: DateTime.now().toISODate(),
      selectedTo: DateTime.now().toISODate()
    },
    remote: {
      crew: "ALL",
      shift: "ALL"
    }
  },
  messageContext: null,
  window: {
    screenOrientation: "portrait",
    width: window.innerWidth,
    height: window.innerHeight
  }
};

const reducer = (state: types.IState = initialState, action: types.IAction): types.IState => {
  logger("reducer", action);

  if (action.type === actions.MULTI_ACTION) {
    let lastState = state;

    for (const item of action.payload) {
      lastState = reducer(lastState, item);
    }

    return lastState;
  }

  switch (action.type) {
    case actions.SET_DATA_CONTEXT:
      return Object.assign({}, state, {
        dataContext: action.payload
      });

    case actions.TOGGLE_RIGHT_PANEL:
      return Object.assign({}, state, {
        panels: Object.assign({}, state.panels, {
          right: !state.panels.right
        })
      });

    case actions.TOGGLE_LEFT_PANEL:
      return Object.assign({}, state, {
        panels: Object.assign({}, state.panels, {
          left: !state.panels.left
        })
      });

    case actions.TOGGLE_BOTTOM_PANEL:
      return Object.assign({}, state, {
        panels: Object.assign({}, state.panels, {
          bottom: !state.panels.bottom
        })
      });

    case actions.TOGGLE_DARK_MODE:
      return Object.assign({}, state, {
        darkMode: action.payload as boolean
      });

    case actions.SET_LANGUAGE:
      return Object.assign({}, state, {
        language: action.payload
      });

    case actions.ADD_ALERT:
      return Object.assign({}, state, {
        alerts: [...state.alerts, { ...action.payload, hash: getUID() }]
      });

    case actions.DEL_ALERT:
      return Object.assign({}, state, {
        alerts:  state.alerts.filter(x => x.hash !== action.payload)
      });

    case actions.SELECTED_NODE:
      return Object.assign({}, state, {
        dataContext: null,
        selectedNode: action.payload,
        panels: Object.assign({}, state.panels, {
          left: false
        }),
        filter: Object.assign({}, state.filter, {
          remote: {
            ...state.filter.remote,
            nodeID: action.payload.nodeID,
            nodeType: action.payload.type
          }
        })
      });

    case actions.UPDATE_FILTER_DATA:
      return Object.assign({}, state, {
        filter: action.payload
      });

    case actions.SHOW_MESSAGE:
      return Object.assign({}, state, {
        messageContext: action.payload
      });

    default:
      return state;
  }
};

export default reducer;
